import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Button } from 'gdpp-components/dist/cjs/components/atoms'

import { Table } from 'gdpp-components/dist/cjs/components/molecules'
import GridContainer from '../../atoms/FoundationGrid/GridContainer'
import Grid from '../../atoms/FoundationGrid/Grid'

import './style.scss'

const FundDetailDividendRecordsTab = ({ fundDividendRecordsTable, id, disclaimer, children }) => {
  const intl = useIntl()
  const { tableData, document, isOnshoreFund } = fundDividendRecordsTable
  return (
    <GridContainer extraClasses="fil-fund-detail__tab-dividend">
      {children || (
        <React.Fragment>
          {document && (
            <Grid id="fil-fund-detail__tab-dividend__export" extraClasses="fil-fund-detail__tab-dividend__export">
              <Button
                kind="tertiary"
                icon="office-file-pdf-1"
                iconSize="20"
                iconPosition="left"
                label={intl.formatMessage({
                  id: `${
                    isOnshoreFund
                      ? 'fundDetail.tabs.dividendTab.exportDividendOnshore'
                      : 'fundDetail.tabs.dividendTab.exportDividendOffshore'
                  }`
                })}
                extraClasses=""
                url={document}
              />
            </Grid>
          )}
          <Table {...tableData} disclaimer={disclaimer} id={id} isAutoFitWidth size="small" isScrollable={false} />
        </React.Fragment>
      )}
    </GridContainer>
  )
}

FundDetailDividendRecordsTab.propTypes = {
  id: PropTypes.string.isRequired,
  fundDividendRecordsTable: PropTypes.object,
  disclaimer: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  children: PropTypes.any
}

FundDetailDividendRecordsTab.defaultProps = {
  fundDividendRecordsTable: {},
  disclaimer: '',
  children: null
}

export default FundDetailDividendRecordsTab
